import { render } from "./NotificationsConfiguration.vue?vue&type=template&id=58f41b9a&scoped=true"
import script from "./NotificationsConfiguration.vue?vue&type=script&lang=js"
export * from "./NotificationsConfiguration.vue?vue&type=script&lang=js"

import "./NotificationsConfiguration.vue?vue&type=style&index=0&id=58f41b9a&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f41b9a"]])

export default __exports__